// extracted by mini-css-extract-plugin
export var hideEditor = "_ig-2";
export var infoIcon = "_ig-3";
export var label = "_ig-1";
export var labelContainer = "_ig-0";
export var readonlyText = "_ig-4";